import { Presenter } from '../../../common/ddd/presenter.base';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfDigitalIntensityScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-digital-intensity-score-averages-summary.entity';
import { SelfDigitalWorkingHoursScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-digital-working-hours-score-averages-summary.entity';
import { SelfFocusScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-focus-score-averages-summary.entity';
import { SelfScreentimeScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-screentime-score-averages-summary.entity';
import { SelfTimeInCallsScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-time-in-calls-score-averages-summary.entity';
import { SelfTimeInMeetingsScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-time-in-meetings-score-averages-summary.entity';
import { SelfTimeInMeetingsScoreAveragesSummaryMapper } from '../../../infrastructure/mappers/scores/self-time-in-meetings-score-averages-summary.mapper';
import { SelfDigitalIntensityScoreAveragesSummaryMapper } from '../../../infrastructure/mappers/scores/self-digital-intensity-score-averages-summary.mapper';
import { SelfDigitalWorkingHoursScoreAveragesSummaryMapper } from '../../../infrastructure/mappers/scores/self-digital-working-hours-score-averages-summary.mapper';
import { SelfFocusScoreAveragesSummaryMapper } from '../../../infrastructure/mappers/scores/self-focus-score-averages-summary.mapper';
import { SelfScreentimeScoreAveragesSummaryMapper } from '../../../infrastructure/mappers/scores/self-screentime-score-averages-summary.mapper';
import { SelfTimeInCallsScoreAveragesSummaryMapper } from '../../../infrastructure/mappers/scores/self-time-in-calls-score-averages-summary.mapper';
import { GetSelfScoreAveragesSummaryResponseDto } from '../../dtos/scores/self-get-score-averages-summary.response.dto';

type ScoreAverageSummaries =
  | SelfTimeInMeetingsScoreAveragesSummaryEntity
  | SelfTimeInCallsScoreAveragesSummaryEntity
  | SelfDigitalIntensityScoreAveragesSummaryEntity
  | SelfFocusScoreAveragesSummaryEntity
  | SelfScreentimeScoreAveragesSummaryEntity
  | SelfDigitalWorkingHoursScoreAveragesSummaryEntity;
export class GetSelfScoreAveragesSummaryPresenter
  implements
    Presenter<ScoreAverageSummaries, GetSelfScoreAveragesSummaryResponseDto>
{
  constructor(
    protected readonly logManager: LogManager,
    protected readonly timeInMeetingsScoreAveragesSummaryMapper: SelfTimeInMeetingsScoreAveragesSummaryMapper,
    protected readonly timeInCallsScoreAveragesSummaryMapper: SelfTimeInCallsScoreAveragesSummaryMapper,
    protected readonly digitalIntensityScoreAveragesSummaryMapper: SelfDigitalIntensityScoreAveragesSummaryMapper,
    protected readonly focusScoreAveragesSummaryMapper: SelfFocusScoreAveragesSummaryMapper,
    protected readonly screentimeScoreAveragesSummaryMapper: SelfScreentimeScoreAveragesSummaryMapper,
    protected readonly digitalWorkingHoursScoreAveragesSummaryMapper: SelfDigitalWorkingHoursScoreAveragesSummaryMapper
  ) {}

  toResponse(
    entity: ScoreAverageSummaries
  ): GetSelfScoreAveragesSummaryResponseDto {
    try {
      if (entity instanceof SelfTimeInMeetingsScoreAveragesSummaryEntity) {
        return this.timeInMeetingsScoreAveragesSummaryMapper.toResponse(entity);
      }
      if (entity instanceof SelfTimeInCallsScoreAveragesSummaryEntity) {
        return this.timeInCallsScoreAveragesSummaryMapper.toResponse(entity);
      }
      if (entity instanceof SelfDigitalIntensityScoreAveragesSummaryEntity) {
        return this.digitalIntensityScoreAveragesSummaryMapper.toResponse(
          entity
        );
      }
      if (entity instanceof SelfFocusScoreAveragesSummaryEntity) {
        return this.focusScoreAveragesSummaryMapper.toResponse(entity);
      }
      if (entity instanceof SelfScreentimeScoreAveragesSummaryEntity) {
        return this.screentimeScoreAveragesSummaryMapper.toResponse(entity);
      }
      if (entity instanceof SelfDigitalWorkingHoursScoreAveragesSummaryEntity) {
        return this.digitalWorkingHoursScoreAveragesSummaryMapper.toResponse(
          entity
        );
      }
    } catch (error) {
      throw new Error(
        `GetSelfScoreAveragesSummaryPresenter.toResponse encountered an error ${error}`
      );
    }
  }
}
